import { gsap } from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../../helpers/initScrollTrigger';

import { Gradient } from '../../helpers/gradient.js';
import сustomPageScroll from './../custom-scroll';
import { getNewLottieAnim } from '../../helpers/lottie';
import { CLASSES, IS_TOUCH, IS_PHONE, IS_SAFARI } from '../../helpers/consts';

gsap.registerPlugin(ScrollTrigger);

let heroLottie = null;

let HeroGradient = null;

const initHeroAnims = () => {
	initScrollTrigger();

	const hero = document.querySelector('.js-home-hero');
	if(hero) {
		// const main = hero.querySelector('.js-home-hero-main');
		const heroLottieEl = hero.querySelector('.js-home-hero-lottie');
		if(heroLottieEl) {
			heroLottie = getNewLottieAnim(heroLottieEl, {
				renderer: IS_SAFARI ? 'canvas' : 'svg',
				// renderer: 'svg',
			});
		}

		if(!IS_PHONE) {
			HeroGradient = new Gradient();
			HeroGradient.initGradient('#hero-gradient-canvas');
		}
	}
};

export const playHeroLottie = () => {
	if(heroLottie) heroLottie.play();
}

export const pauseHeroGradient = () => {
	console.log('pauseHeroGradient');
	if(HeroGradient) HeroGradient.pause();
}

export default initHeroAnims;
